import * as types from '../actions/actionTypes';
import initialState from './initialState';

//handle all ui state transitions in a single reducer
export default function uiReducer(state = initialState.ui, action) {
	switch (action.type) {
		case types.SET_SNACKBAR_STATUS:
			return {
				...state,
				snackBar: {
					...state.snackBar,
					open: true,
					severity: action.data.severity,
					message: action.data.message,
				},
			};
		case types.CLEAR_SNACKBAR:
			return {
				...state,
				snackBar: {
					...state.snackBar,
					open: false,
				},
			};
		case types.OPEN_ALERT_DIALOG:
			return {
				...state,
				dialog: {
					...state.dialog,
					open: true,
					title: action.data.title,
					content: action.data.content,
					size: action.data.size,
				},
			};
		case types.CLOSE_ALERT_DIALOG:
			return {
				...state,
				dialog: {
					...state.dialog,
					open: false,
					title: '',
					content: '',
				},
			};
		case types.OPEN_BACKDROP_OVERLAY:
			return {
				...state,
				backDrop: {
					...state.backDrop,
					open: true,
					message: action.data,
				},
			};
		case types.CLOSE_BACKDROP_OVERLAY:
			return {
				...state,
				backDrop: {
					...state.backDrop,
					open: false,
					message: '',
				},
			};
		default:
			return state;
	}
}
